import React, { useState } from 'react';
import { colors } from './theme';
import { analyticsCardStyles as card } from './analytics/analyticsCardStyles';

export default function BuildOrderAnalyticsCard({ stats }) {
  const [type, setType] = useState('overall');
  if (!stats) return null;

  const { onTimeDeliveries, lateDeliveries, dueSummary } = stats;
  const totalDeliveries = onTimeDeliveries + lateDeliveries;
  const percentOnTime = totalDeliveries ? Math.round((onTimeDeliveries / totalDeliveries) * 100) : 0;

  const dueColors = {
    overdue: colors.danger,
    dueSoon: colors.statusYellow,
    dueWeek: colors.accent,
    onTrack: colors.success,
  };

  const categories = [
    { key: 'overdue', label: 'Overdue' },
    { key: 'dueSoon', label: 'Due &lt;=3 days' },
    { key: 'dueWeek', label: 'Due &lt;=7 days' },
    { key: 'onTrack', label: 'On Track' },
  ];

  const max = Math.max(...categories.map(c => dueSummary[c.key] || 0), 1);

  return (
    <div style={{ ...card.shell, maxWidth: '700px' }}>
      <div style={card.header}>
        <div style={card.titleWrap}>
          <p style={card.eyebrow}>Delivery health</p>
          <h2 style={card.title}>Production KPIs</h2>
        </div>
        <select className="ni-select" value={type} onChange={e => setType(e.target.value)} style={{ minWidth: '140px' }}>
          <option value="overall">Overall</option>
          <option value="gpv">GPV</option>
          <option value="uti">UTI</option>
        </select>
      </div>
      <div style={card.body}>
        <div style={card.statRow}>
          <span style={card.statLabel}>On-time deliveries</span>
          <strong style={card.statValue}>{percentOnTime}%</strong>
        </div>
        <section style={card.section}>
          <h4 style={card.sectionTitle}>Units By Timeline</h4>
          <ul style={card.list}>
            {categories.map(cat => (
              <li key={cat.key} style={{ ...card.listRow, alignItems: 'center' }}>
                <span style={{ width: '10px', height: '10px', borderRadius: '50%', backgroundColor: dueColors[cat.key], display: 'inline-block', marginRight: '0.5rem' }}></span>
                <span style={{ flex: '0 0 130px', color: colors.textBody }}>{cat.label}</span>
                <div style={card.barTrack}>
                  <div style={{ ...card.bar, height: '7px', width: `${(dueSummary[cat.key] / max) * 100}%`, backgroundColor: dueColors[cat.key] }}></div>
                </div>
                <span style={card.statValue}>{dueSummary[cat.key] || 0}</span>
              </li>
            ))}
          </ul>
        </section>
      </div>
    </div>
  );
}
